<template>
  <div>
    <router-link :to="`/credit`" class="credit-button">
      <div class="flex items-center gap-1" style="display: flex; flex-wrap: wrap;  justify-content: center;
    align-items: center; ">
        <span class="material-symbols-outlined" style="font-size: 16px;">
          credit_card
        </span>
        <span class="hidden lg:block"> Credit:</span>
        <span>{{ credit }}</span>

      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  computed: {
    credit() {
      return this.$storex.getters.getCredit.toFixed(2);
    }
  }
}
</script>

<style scoped>
.credit-button {
  background: linear-gradient(135deg, #7e57c2, #5e35b1);
  color: white;
  border: none;
  padding: 0.2rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease, transform 0.2s ease;
  box-shadow: 0 2px 8px rgba(126, 87, 194, 0.3);
}

.credit-button:hover {
  background: linear-gradient(135deg, #5e35b1, #7e57c2);
  transform: scale(1.03);
}

a {
  color: #000;
  text-decoration: none !important;
}
</style>
